import ClearIcon from '@mui/icons-material/Clear';
/* import DeleteIcon from '@mui/icons-material/Delete'; */
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { Button, Container, FormControl, InputLabel, MenuItem, Modal, Select, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { UserRoles } from '../../redux/reducers/authenticationReducer';
import { selectPersonDetails, selectUserRole, updateOrganizationUser } from '../../redux/reducers/organizationReducer';

export default function EditUserModal({ handleClose, contactId }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const details = useSelector((state) => selectPersonDetails(state, contactId));
  const role = useSelector(selectUserRole);
  const [userDetails, setUserDetails] = useState({});
  const [editMode, setEditMode] = useState(false);

  const handleRoleChange = (event) => {
    const newDetails = {
      ...details,
      role: event.target.value,
    };
    setUserDetails(newDetails);
  };

  const handleSave = () => {
    dispatch(updateOrganizationUser(userDetails));
    handleClose(undefined);
  };

  /*   const handleDelete = () => {
    // TODO: implement when functionality is designed
  }; */

  const toggleEdit = () => {
    setEditMode(!editMode);
  };

  useEffect(() => {
    setUserDetails(details);
  }, [details]);

  return (
    <Modal open>
      <Container variant="settingsModal" sx={{ display: 'flex', flexDirection: 'column' }} disableGutters>
        <Container variant="formContainer" disableGutters>
          <Stack direction="column" spacing={2}>
            <Typography variant="h6">{t(`person.user.${editMode ? 'edit' : 'view'}`)}</Typography>

            <Stack>
              <Typography variant="body1">{t('person.modal.firstName')}</Typography>
              <Typography variant="body2">{userDetails.firstName}</Typography>
            </Stack>
            <Stack>
              <Typography variant="body1">{t('person.modal.lastName')}</Typography>
              <Typography variant="body2">{userDetails.lastName}</Typography>
            </Stack>
            <Stack>
              <Typography variant="body1">{t('person.modal.email')}</Typography>
              <Typography variant="body2">{userDetails.email}</Typography>
            </Stack>
            <Stack>
              <Typography variant="body1">{t('person.modal.phone')}</Typography>
              <Typography variant="body2">{userDetails.phone || '-'}</Typography>
            </Stack>
            {editMode ? (
              <FormControl>
                <InputLabel>{t('person.modal.role')}</InputLabel>
                <Select id='edit-role' label={t('person.modal.role')} value={userDetails.role} onChange={(e) => handleRoleChange(e)}>
                  {UserRoles.list().map((role) => (
                    <MenuItem id={role} key={role} value={role}>
                      {t(`person.roles.${role}`)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <Stack>
                <Typography variant="body1">{t('person.modal.role')}</Typography>
                <Typography variant="body2">{t(`person.roles.${userDetails.role}`)}</Typography>
              </Stack>
            )}
          </Stack>
        </Container>
        <Container variant="buttonRow" disableGutters>
          {editMode ? (
            <Stack direction="row" justifyContent="flex-end">
              {/* TODO: return when functionality is designed, remember to change containing stack's justify */}
              {/* <Button onClick={handleDelete} variant="contained" startIcon={<DeleteIcon />}>{t('person.user.delete')}</Button> */}
              <Stack direction="row" spacing={1}>
                <Button id='cancel' variant="text" startIcon={<ClearIcon />} onClick={() => handleClose(undefined)}>
                  {t('person.modal.buttonCancel')}
                </Button>
                <Button id='save' variant="contained" startIcon={<SaveIcon />} onClick={() => handleSave()}>
                  {t('organization.buttonSaveEdit')}
                </Button>
              </Stack>
            </Stack>
          ) : (
            <Stack direction="row" justifyContent="flex-end" spacing={1}>
              {role === UserRoles.ADMIN ? (
                <>
                  <Button variant="text" startIcon={<ClearIcon />} onClick={() => handleClose(undefined)}>
                    {t('person.modal.buttonClose')}
                  </Button>
                  <Button variant="contained" startIcon={<EditIcon />} onClick={toggleEdit}>
                    {t('person.user.edit')}
                  </Button>
                </>
              ) : (
                <Button variant="contained" onClick={() => handleClose(undefined)}>
                  <Typography variant="buttonMedium">{t('person.modal.ok')}</Typography>
                </Button>
              )}
            </Stack>
          )}
        </Container>
      </Container>
    </Modal>
  );
}
